import { formatarDataVencimentoPortal, formatarValorMonetarioPortal } from './condicoesComerciaisPortal';

// Fase E.3 -- funcoes PURAS de apresentacao dos PAGAMENTOS de Eventos
// no Portal do Responsavel ("como e quando eu pago", NUNCA "quanto
// ficou minha participacao" -- isso e' E.2, condicoesComerciaisPortal.js).
// Mesmo padrao de modulo separado testavel via Jest puro (sem
// Testing Library) ja estabelecido em toda a Fase E.
//
// O frontend NUNCA interpreta vocabulario tecnico (RESULTADO_INCERTO/
// ERRO_PROVIDER/ENVIANDO/CONFLITO_PAGAMENTO/lifecycle_status/Attempt) --
// so' consome os 5 valores da taxonomia amigavel ja' derivada pelo
// backend (evento_cobranca_portal_service.py). Reutiliza `formatarValor
// MonetarioPortal`/`formatarDataVencimentoPortal` de E.2 -- MESMA
// licao E.1/E.2 sobre Decimal serializado como string pelo Pydantic v2,
// nunca uma segunda implementacao.

export const ESTADO_AGUARDANDO_GERACAO = 'AGUARDANDO_GERACAO';
export const ESTADO_AGUARDANDO_PAGAMENTO = 'AGUARDANDO_PAGAMENTO';
export const ESTADO_PAGO = 'PAGO';
export const ESTADO_CANCELADO = 'CANCELADO';
export const ESTADO_INDISPONIVEL = 'INDISPONIVEL';

const LABEL_POR_ESTADO = {
  [ESTADO_AGUARDANDO_GERACAO]: 'Aguardando geração',
  [ESTADO_AGUARDANDO_PAGAMENTO]: 'Aguardando pagamento',
  [ESTADO_PAGO]: 'Pago',
  [ESTADO_CANCELADO]: 'Cancelado',
  [ESTADO_INDISPONIVEL]: 'Indisponível',
};

const COR_POR_ESTADO = {
  [ESTADO_AGUARDANDO_GERACAO]: 'default',
  [ESTADO_AGUARDANDO_PAGAMENTO]: 'blue',
  [ESTADO_PAGO]: 'green',
  [ESTADO_CANCELADO]: 'default',
  [ESTADO_INDISPONIVEL]: 'orange',
};

export const MENSAGEM_INDISPONIVEL =
  'Pagamento temporariamente indisponível. Entre em contato com a Fisicore.';

/** Rotulo amigavel em pt-BR -- vocabulario desconhecido/nao mapeado
 * (fail closed) cai em "Indisponível", NUNCA mostra o codigo tecnico
 * bruto recebido. */
export function labelEstadoPagamentoPortal(estado) {
  return LABEL_POR_ESTADO[estado] || LABEL_POR_ESTADO[ESTADO_INDISPONIVEL];
}

export function corEstadoPagamentoPortal(estado) {
  return COR_POR_ESTADO[estado] || COR_POR_ESTADO[ESTADO_INDISPONIVEL];
}

/** Reexportadas de condicoesComerciaisPortal.js para uso direto neste
 * dominio, sem duplicar a regra Decimal-string/data-civil. */
export { formatarDataVencimentoPortal, formatarValorMonetarioPortal };

/** URL so' conta como presente quando e' string com conteudo real apos
 * trim -- mesma regra ja aplicada em toda a Fase E.1/E.1.1
 * (cobrancasEventosAcoes.js::normalizarUrlBoleto) -- nunca duplicada,
 * so' reaplicada aqui por ser um modulo de dominio diferente (Portal,
 * nao Admin). O backend ja normaliza, mas o frontend verifica de novo
 * por defesa em profundidade (mesmo principio de `inscricaoTemCondicoes
 * Comerciais`). */
export function pagamentoTemUrlBoletoValida(pagamento) {
  const url = pagamento?.url_boleto;
  return typeof url === 'string' && url.trim().length > 0;
}

export function pagamentoTemLinhaDigitavelValida(pagamento) {
  const linha = pagamento?.linha_digitavel;
  return typeof linha === 'string' && linha.trim().length > 0;
}

/** Botao "Abrir boleto"/"Copiar linha digitavel" SOMENTE quando o
 * estado amigavel e' AGUARDANDO_PAGAMENTO -- nunca PAGO/CANCELADO/
 * INDISPONIVEL/AGUARDANDO_GERACAO, mesmo que (por algum motivo) o
 * campo ainda viesse preenchido. Dupla checagem (estado + valor
 * presente) -- nunca confia em so' um dos dois. */
export function pagamentoPodeAbrirBoleto(pagamento) {
  return pagamento?.estado === ESTADO_AGUARDANDO_PAGAMENTO && pagamentoTemUrlBoletoValida(pagamento);
}

export function pagamentoPodeCopiarLinhaDigitavel(pagamento) {
  return pagamento?.estado === ESTADO_AGUARDANDO_PAGAMENTO && pagamentoTemLinhaDigitavelValida(pagamento);
}

/** "Pagamento consolidado · N itens" ou "Pagamento individual" --
 * nunca expõe documento_id/group_id/charge_id ao texto apresentado. */
export function descricaoTipoDocumentoPortal(pagamento) {
  if (!pagamento) return '';
  if (pagamento.consolidado) {
    const quantidade = pagamento.quantidade_itens ?? 0;
    return `Pagamento consolidado · ${quantidade} ${quantidade === 1 ? 'item' : 'itens'}`;
  }
  return 'Pagamento individual';
}

/** Cada item vira uma linha "Evento — Parcela N" (sessao_nome nunca
 * exposta aqui de proposito -- o card ja mostra vencimento/valor do
 * documento inteiro, o item so' precisa dizer O QUE compoe). */
export function formatarItemPagamentoPortal(item) {
  if (!item) return '';
  const evento = item.evento_nome || 'Evento';
  return `${evento} — Parcela ${item.numero_parcela ?? '—'}`;
}
